import types from '../mutations/mutation-types';
import api from '../../utils/api';

export default {
  state: {
    commonReplies: {},
    intentMessages: {},
    frequentlyUsedDetails: {},
    keywords: []
  },
  mutations: {
    [types.GENERAL.LOAD_COMMON_REPLIES](state, replies) {
      state.commonReplies = replies;
    },
    [types.GENERAL.LOAD_INTENT_MESSAGES](state, messages) {
      state.intentMessages = messages;
    },
    [types.GENERAL.SET_FREQUENTLY_USED_DETAILS](state, details) {
      state.frequentlyUsedDetails = details;
    },
    [types.GENERAL.LOAD_KEYWORDS](state, keywords) {
      state.keywords = keywords;
    }
  },
  actions: {
    loadCommonReplies({ commit }) {
      return new Promise((resolve) => {
        api.buildRequest('common-replies', 'GET')
          .then(({ data }) => {
            commit(types.GENERAL.LOAD_COMMON_REPLIES, data.payload);
            resolve();
          });
      });
    },
    loadIntentMessages({ commit }) {
      return new Promise((resolve) => {
        api.buildRequest('intents', 'GET')
          .then(({ data }) => {
            commit(types.GENERAL.LOAD_INTENT_MESSAGES, data.payload);
            resolve();
          });
      });
    },
    setFrequentlyUsedDetails({ commit }, details) {
      commit(types.GENERAL.SET_FREQUENTLY_USED_DETAILS, details);
    },
    loadKeywords({ commit }) {
      return new Promise((resolve) => {
        api.buildRequest('keywords', 'GET')
          .then(({ data }) => {
            commit(types.GENERAL.LOAD_KEYWORDS, data.payload);
            resolve();
          });
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/general.js